import { SvgIcon, SvgIconProps } from '@mui/material'

const Bookings = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 29 29" fill="none">
        <path
            d="M12.082 4.83398V24.1673"
            fill="none"
            stroke="#E7C900"
            strokeWidth="1.8125"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="6.04 6.04"
        />
        <path
            d="M23.5618 15.1048C23.5618 13.4373 24.9152 12.084 26.5827 12.084V10.8757C26.5827 6.04232 25.3743 4.83398 20.541 4.83398H8.45768C3.62435 4.83398 2.41602 6.04232 2.41602 10.8757V11.4798C4.08352 11.4798 5.43685 12.8332 5.43685 14.5007C5.43685 16.1682 4.08352 17.5215 2.41602 17.5215V18.1257C2.41602 22.959 3.62435 24.1673 8.45768 24.1673H20.541C25.3743 24.1673 26.5827 22.959 26.5827 18.1257C24.9152 18.1257 23.5618 16.7723 23.5618 15.1048Z"
            fill="none"
            stroke="#1C60AB"
            strokeWidth="1.8125"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
)

export default Bookings
